module.exports = __webpack_public_path__ + "assets/83d2521dec54cf2a532f7f2bf9502a7a.mp3";